import { render, staticRenderFns } from "./TabletMenu.vue?vue&type=template&id=787ec2f0&"
import script from "./TabletMenu.vue?vue&type=script&lang=js&"
export * from "./TabletMenu.vue?vue&type=script&lang=js&"
import style0 from "./TabletMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports